export default __webpack_public_path__ + "static/media/SS10-min.cdcb5356.jpg";